export const parseEventState = state => {
  switch (state) {
    case 'waiting':
      return 'page.finance.event.status.waiting'
      // return {
      //   title: 'page.finance.event.status.waiting',
      //   icon: WaitingStatusIcon,
      // }
    case 'performed':
    case 'approve':
    case 'approved':
    case 'transferred':
    case 'paid':
      return 'page.finance.event.status.approved'
      // return {
      //   title: 'page.finance.event.status.approved',
      //   icon: SuccessStatusIcon,
      // }
    case 'canceled':
    case 'cancel':
      return 'page.finance.event.status.canceled'
    case 'rejected':
    case 'reject':
      return 'page.finance.event.status.rejected'
      // return {
      //   title: 'page.finance.event.status.rejected',
      //   icon: FailStatusIcon,
      // }
    default:
      return null
  }
}
